import {PaymentLinkPdfDownloadRequest} from '@/api'

export const buildPdfRequest = (
    data: PaymentLinkPdfDownloadRequest
): PaymentLinkPdfDownloadRequest => {
    return {
        ...data
    }
}
